import { render, staticRenderFns } from "./ProductWorkflow.vue?vue&type=template&id=183a1ae8"
import script from "./ProductWorkflow.vue?vue&type=script&lang=js"
export * from "./ProductWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports